import { Store } from "@/store";
import { storeToRefs } from "pinia";
import { WechatAppID, RedirectServerUrl, WechatLoginUrl } from "./Const";
import { ResponseData } from "./Interface";
import { IMember } from "./Member";
import { HttpHelper, Utils } from "./Utils";

const UserUrl = {
	loginBrowser: "user/login-browser",
	register: "user/register",
	getUser: "user/get-user",
	getMember: "user/get-member",
	emptyPage: "user/empty-page"
}

export class UserUtils {

	//#region 登录
	static async Login(userName: string, password: string) {
		const { token, user } = storeToRefs(Store());
		try {
			let response = (await HttpHelper.post<ResponseData<{ user: IUser, token: string }>>(UserUrl.loginBrowser, { userName, password })).data;
			if (!response.success)
				return response.reason;

			token.value = response.data.token;
			user.value = response.data.user;
		} catch (e) {
			let error = <ResponseData<any>>e;
			return error.reason;
		}
	}
	//#endregion 登录

	//#region 使用微信登录
	static async LoginWithWechat() {
		let redirectUri = encodeURIComponent(RedirectServerUrl);
		let date = new Date().getMilliseconds().toString();
		let url = Utils.StringFormat(WechatLoginUrl, WechatAppID, redirectUri, date);
		location.href = url;
	}
	//#endregion 使用微信登录

	//#region 注册
	static async Register(loginName: string, password: string, nickName: string) {
		let response = await HttpHelper.post<ResponseData<any>>(UserUrl.register, { loginName, password, nickName });
		if (!response.data.success)
			return response.data.reason;

		return null;
	}
	//#endregion 注册

	//#region 获取用户
	static async GetUser() {
		let response = await HttpHelper.post<ResponseData<{ user: IUser }>>(UserUrl.getUser);
		if (!response.data.success)
			return null;

		return response.data.data;
	}
	//#endregion 获取用户

	//#region 获取会员信息
	static async GetMember() {
		try {
			let response = await HttpHelper.post<ResponseData<{ member: IMember }>>(UserUrl.getMember);
			if (!response.data.success)
				return null;

			return response.data.data;
		} catch {
			return null;
		}
	}
	//#endregion 获取会员信息

	/***** 管理方法 *****/

	//#region 判断是否是系统后台管理员
	static async GetAdminRoles() {
		let response = await HttpHelper.post<ResponseData<IUser>>(UserUrl.emptyPage);
		if (!response.data.success)
			return null
		
		return response.data.data;
	}
	//#endregion 判断是否是系统后台管理员

}

export interface IUser {
	nickName: string;
	loginName: string;
	registerTime: string;
}